import React, {useEffect} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Sidebar} from "primereact/sidebar";

import _FM_GirpadditionalfieldcollectionListComponent from "../components/_FM_girpadditionalfieldcollection/_FM_GirpadditionalfieldcollectionListComponent";
import _FM_GirpadditionalfieldcollectionFormComponent from "../components/_FM_girpadditionalfieldcollection/_FM_GirpadditionalfieldcollectionFormComponent";
import _FM_GirpadditionalfieldcollectionShowComponent from "../components/_FM_girpadditionalfieldcollection/_FM_GirpadditionalfieldcollectionShowComponent";

const _FM_GirpadditionalfieldcollectionPage = (props) => {

  const {t} = props;
  const navigate = useNavigate();
  const {action} = useParams();

  useEffect(() => {
    document.title = t('girp_additional_field_collections') + ' - ' + process.env.REACT_APP_TITLE;
  }, []);

  return (
    <div className="_FM_GirpadditionalfieldcollectionPage p-component p-m-lg-4">
      <Panel>
        <_FM_GirpadditionalfieldcollectionListComponent/>
      </Panel>
      <Sidebar position="right" visible={action === 'update' || action === 'create'} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {
                 navigate('/girp-additional-field-collection');
               }}>
        <_FM_GirpadditionalfieldcollectionFormComponent/>
      </Sidebar>
      <Sidebar position="right" visible={action === 'read'} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {
                 navigate('/girp-additional-field-collection');
               }}>
        <_FM_GirpadditionalfieldcollectionShowComponent/>
      </Sidebar>
    </div>
  )
}
export default withTranslation('common')(_FM_GirpadditionalfieldcollectionPage);
